import StakeInput from "./StakeInput";

export default StakeInput;
